import React from 'react';
import ReactDOM from 'react-dom/client';
import { FAQAnswerPage } from './FAQAnswerPage';
import { FAQ } from './IFAQAnswer';
import '~/styles/main.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

interface WindowWithData extends Window {
  data: FAQ;
}

const { data } = window as unknown as WindowWithData;

root.render(
  <React.StrictMode>
    <FAQAnswerPage {...data} />
  </React.StrictMode>
);
